import PropTypes from "prop-types"
import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { isTestEnvironment } from "../../utils/testing"

const Icon = ({ preloadWidth, icon, ...props }) =>
  isTestEnvironment() ? (
    <span className={`ICON-${icon.iconName}`} />
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FontAwesomeIcon width={preloadWidth} {...props} icon={icon} />
  )

Icon.propTypes = {
  /*
   * This defines the icon's "default width" before CSS, inline styling etc takes effect.
   * It defaults to 16 to make sure we don't flash a huge icon on page load, but can be
   * overridden if this still looks inappropriate for your use case. The intention is that
   * in almost all cases <Icon> should be usable as an invisible wrapper to <FontAwesomeIcon>
   * without altering this prop.
   */
  preloadWidth: PropTypes.number,
  icon: PropTypes.shape({
    iconName: PropTypes.string,
  }).isRequired,
}
Icon.defaultProps = {
  preloadWidth: 16,
}

export default Icon
